export const mountBuildingLibraryCards = () => {
  document.querySelectorAll("[data-building-card-href]").forEach((card) => {
    if (card.dataset.buildingCardBound === "true") return

    card.dataset.buildingCardBound = "true"
    card.tabIndex = 0
    card.setAttribute("role", "link")

    const navigate = () => {
      const href = card.dataset.buildingCardHref
      if (href) window.location.href = href
    }

    card.addEventListener("click", (event) => {
      if (event.target.closest("a,button,input,select,textarea,label,form")) return
      navigate()
    })

    card.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return
      if (event.target.closest("a,button,input,select,textarea,label,form")) return
      event.preventDefault()
      navigate()
    })
  })
}
